import React, { useContext } from 'react';
import { Controller } from 'react-hook-form';
import ReactSelect from 'react-select';

import FormData from './Form.context';
import Label from './Label.form';
import ErrorMsg from './ErrorMsg.form';

const Select = props => {
	const {
		required = false,
		name,
		options = [],
	} = props;

	const { control } = useContext(FormData);

	const customStyles = {
		control: base => ({
			...base,
			height: 40,
			minHeight: 40,
		}),
		valueContainer: base => ({
			...base,
			height: '100%',
		}),
		singleValue: base => ({
			...base,
			top: 26,
		}),
	};

	return (
		<div className='form-group-old'>
			<Label {...props} />

			<Controller
				render={() =>
					<ReactSelect
						options={options}
						styles={customStyles}
						isClearable={true}
					/>
				}
				options={options}
				name={name}
				isClearable
				control={control}
				rules={{ required: { value: required, message: 'Required' } }}
			/>

			<ErrorMsg {...props} />
		</div>
	);
};

export default Select;
